import { gql } from "@apollo/client";
import { useQueryWithSimpleErrorHandling } from "hooks";
import { INSURANCE_DATA_EXCHANGE_QUERY } from "features/insuranceDocument/queries/insuranceDocumentQueries";
import { useApolloClient } from "@apollo/client";
import initialSteps from "constants/initialSteps";

const NAVIGATION_STEP_QUERY = gql`
  query navigationStep($documentId: Int!) {
    navigationStep(documentId: $documentId)
  }
`;

export function useNavigationStepData() {
  const client = useApolloClient();

  const useGetNavigationStep = documentId => {
    const { insuranceDataExchange } = client.readQuery({ query: INSURANCE_DATA_EXCHANGE_QUERY });
    const cachedStepCode = insuranceDataExchange?.documentsSteps?.find(
      x => x.documentId === documentId
    )?.navigationStepCode;
    let stepCode;

    const { data: navigationStepData } = useQueryWithSimpleErrorHandling(NAVIGATION_STEP_QUERY, {
      variables: { documentId: documentId },
      skip: Boolean(cachedStepCode || !documentId)
    });

    if (cachedStepCode) {
      setNavigationStep(documentId, cachedStepCode);
      stepCode = cachedStepCode;
    } else {
      setNavigationStep(documentId, navigationStepData?.navigationStep);
      stepCode = navigationStepData?.navigationStep;
    }
    const stepIndex = initialSteps.find(x => x.code === stepCode)?.index;
    return { code: stepCode, index: stepIndex };
  };

  const setNavigationStep = (documentId, navigationStepCode) => {
    const { insuranceDataExchange } = client.readQuery({ query: INSURANCE_DATA_EXCHANGE_QUERY });
    const currentDocumentsSteps = insuranceDataExchange?.documentsSteps || [];
    client.writeQuery({
      query: INSURANCE_DATA_EXCHANGE_QUERY,
      data: {
        insuranceDataExchange: {
          __typename: "insuranceDataExchange",
          ...insuranceDataExchange,
          documentsSteps: [
            ...currentDocumentsSteps.filter(x => x.documentId !== documentId),
            { documentId, navigationStepCode }
          ]
        }
      }
    });
  };

  return { useGetNavigationStep, setNavigationStep };
}
